import { Button } from "components/ui/button"
import { Loader2 } from "lucide-react"
import React from "react"
import { useStepperNavigation } from "components/common/stepper/CustomStepper"

export const StepperNavigationButtons = ({
  // onNext,
  onPrevious,
  nextLabel = "Suivant",
  previousLabel = "Retour",
  nextDisabled = false,
  previousDisabled = false,
  isLoading = false,
  handleNext = ()=> {},
  handlePrevious = ()=>{}
}: {
  // onNext?: () => void | Promise<void>;
  onPrevious?: () => void | Promise<void>;
  nextLabel?: string;
  previousLabel?: string;
  nextDisabled?: boolean;
  previousDisabled?: boolean;
  isLoading?: boolean;
  handleNext?: () => void | Promise<void>;
  handlePrevious?: () => void | Promise<void>;
}) => {
  const {
    isFirstStep,
    isLastStep,
    goToNext,
    goToPrevious,
    isNavigating,
    setIsNavigating,
  } = useStepperNavigation();

  // const handlePrevious = async () => {
  //   if (onPrevious) {
  //     setIsNavigating(true);
  //     try {
  //       await onPrevious();
  //       goToPrevious();
  //     } catch (error) {
  //       console.error("Error in onPrevious:", error);
  //     } finally {
  //       setIsNavigating(false);
  //     }
  //   } else {
  //     goToPrevious();
  //   }
  // };

  return (
    <div className="w-full flex items-center justify-end gap-2.5 pt-6">
      <Button
        type="button"
        variant="outline"
        onClick={handlePrevious}
        className="h-full font-semibold"
        disabled={isFirstStep || previousDisabled || isNavigating || isLoading}>
        {previousLabel}
      </Button>

      <Button
        type="button"
        onClick={ handleNext}
        disabled={nextDisabled || isNavigating || isLoading}>
        {isNavigating || isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            {nextLabel}
          </>
        ) : (
          nextLabel
        )}
      </Button>
    </div>
  )
};